import api from "./helper/client";

export interface UserDeviceRecord {
    id: number;
    user_id: number;
    user_name?: string;
    user_email?: string;
    device_id: string;
    device_name?: string;
    device_type?: string;
    last_login_at?: string;
    is_active: boolean;
    created_at?: string;
}

/** All device records for a single user (full history) */
export const getUserDevices = async (userId: number): Promise<UserDeviceRecord[]> => {
    const response = await api.get(`/devices/user/${userId}`);
    return response.data.data ?? [];
};

/** All device records across every user in the tenant */
export const getTenantDevices = async (tenantId: number): Promise<UserDeviceRecord[]> => {
    const response = await api.get(`/devices/tenant/${tenantId}`);
    return response.data.data ?? [];
};

/** Deactivate all devices for a user so they can log in from a new device */
export const clearUserDevice = async (userId: number): Promise<void> => {
    await api.post("/devices/clear", { user_id: userId });
};
